import IconButton from "@mui/material/IconButton";
import styled from "@mui/material/styles/styled";

import { BaseFeedbackSnackbarContent } from "@app/analytics/components/reports/ReportFeedbackSnackbar";

export const ContentWrapper = styled(BaseFeedbackSnackbarContent)({
  width: "450px",
});

export const FeedbackButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.transparent.black[20],
  color: "#FFF",
  borderRadius: "8px",
  padding: theme.spacing(2),
  "& .MuiSvgIcon-root": {
    fontSize: "16px",
  },
  "&:hover": {
    backgroundColor: theme.palette.transparent.black[40],
  },
}));
